<template>
  <div class="receiptBaseInfo">
    <base-form
      :options="baseDataOptions"
      :disabled="!canEdit"
      @input="handleChangeBaseData"
      v-model="baseData"
      ref="basicInfo"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  // import SearchTable from '@/components/form-item/search-table';
  export default {
    name: 'basicInfo',
    components: {
      baseForm,
      // SearchTable,
    },
    props: ['canEdit'],
    data() {
      return {
        baseData: {
          orderNo: null,
          interestType: null,
          interestUnit: null,
          occupationPeriod: null,
          settleNo: '未定义结算批次',
        },
      };
    },
    computed: {
      baseDataOptions() {
        return [
          {
            // 框架协议编号
            prop: 'orderNo',
            label: this.$t('sbRateConfig.column.orderNo'),
            type: 'searchTable',
            searchType: 'businessOrder',
            isMultiple: true,
            required: true,
            currentValue: this.baseData.orderNo,
          },
          {
            // 利率类型
            prop: 'interestType',
            label: this.$t('sbRateConfig.column.interestType'),
            type: 'dict',
            dictType: 'sbInterestType',
            required: true,
          },
          {
            // 利率计价单位
            prop: 'interestUnit',
            label: this.$t('sbRateConfig.column.interestUnit'),
            type: 'dict',
            dictType: 'sbInterestUnit',
            required: true,
          },
          {
            // 利率周期
            prop: 'occupationPeriod',
            label: this.$t('sbRateConfig.column.occupationPeriod'),
            type: 'dict',
            dictType: 'sbOccupationPeriod',
            required: true,
          },
          {
            // 结算批次编号
            type: 'searchTable',
            prop: 'settleNo',
            searchType: 'settle',
            isMultiple: true,
            label: this.$t('sbRateConfig.column.settleNo'),
            required: true,
            currentValue: this.baseData.settleNo,
            extraData: {
              orderNo: this.baseData.orderNo,
            },
          },
        ];
      },
    },
    methods: {
      handleChangeBaseData(value, prop) {
        if (prop == 'orderNo') {
          // 框架协议编号
          let val = value.orderNo;
          this.baseData.orderNo = val && val.length > 0 ? val[0].orderNo : null;
          this.baseData.settleNo = '未定义结算批次';
        }
        if (prop == 'settleNo') {
          // 结算批次编号
          let val = value.settleNo;
          this.baseData.settleNo = val && val.length > 0 ? val[0].settleNo : '未定义结算批次';
        }
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.basicInfo.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
